export function phoneMask(value: string) {
    const digits = value.replace(/\D/g, "")

    if (digits.length === 0) return ""

    if (digits.length <= 2) {
        return `(${digits}`
    }

    if (digits.length <= 6) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
    }

    if (digits.length <= 10) {
        return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
    }

    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`
}